'use strict';
angular.module('tcApp')
/**
* @ngdoc directive
* @name tcApp.directive:tcLayoutEditBlock
* @description
* Block element within Layout Editor
*/
.directive('tcLayoutEditBlock', function() {
	return {
			templateUrl: 'template/layoutEdit/block.html',
			restrict: 'E',
			scope: true,
			link: function(scope, element, attrs) {
				var onInit = function() {
					if (angular.isDefined(scope.blockLevel)) {
						// Nested block
						scope.blockLevel++;
						scope.blockId = (scope.blockId + '-row-' + scope.rowIndex + '-nested-' + scope.nestedBlockIndex);
					} else {
						// Section level block
						scope.blockLevel = 1;
						scope.blockId = ('tc_layoutEdit-section-' + scope.sectionIndex + '-block-' + scope.blockIndex);
					}
					
					if (attrs.tcLayoutEditBlockContainer) {
						scope.container = scope[attrs.tcLayoutEditBlockContainer];
					}
				};

				scope.getNestedBlockIndex = function() {
					return ((attrs.tcLayoutEditBlockContainer === 'section') ? scope.blockIndex : scope.nestedBlockIndex);
				};
				
				onInit();
			}
		};
});
